import request from '@/config/axios'

// 提成规则 VO
export interface CommissionRuleVO {
  id?: string | number
  shopId: string | number
  ruleName: string
  ruleType: string // PRODUCT/ROOM/SERVICE/MEMBERSHIP
  targetType: string // EMPLOYEE/POSITION
  targetId: string | number
  targetName?: string
  commissionType: string // SALES/CLEANING/MAINTENANCE
  calculationBase: string // ORDER_AMOUNT/ROOM_COUNT/FIXED
  commissionValue: number
  tierConfig?: string
  minAmount: number
  maxAmount?: number
  effectiveDate: string
  expireDate?: string
  status: number // 0启用 1禁用
  remark?: string
  createTime?: Date
}

// 获取提成规则分页
export const getCommissionRulePage = (params: any) => {
  return request.get({ url: '/hotel/commission-rule/page', params })
}

// 获取提成规则详情
export const getCommissionRule = (id: string | number) => {
  return request.get({ url: '/hotel/commission-rule/get?id=' + id })
}

// 创建提成规则
export const createCommissionRule = (data: CommissionRuleVO) => {
  return request.post({ url: '/hotel/commission-rule/create', data })
}

// 更新提成规则
export const updateCommissionRule = (data: CommissionRuleVO) => {
  return request.put({ url: '/hotel/commission-rule/update', data })
}

// 删除提成规则
export const deleteCommissionRule = (id: string | number) => {
  return request.delete({ url: '/hotel/commission-rule/delete?id=' + id })
}

// 批量删除提成规则
export const deleteCommissionRuleList = (ids: (string | number)[]) => {
  return request.delete({ url: '/hotel/commission-rule/delete-list?ids=' + ids.join(',') })
}
